import { useAuthStore } from '../stores/auth'

const FALLBACK_TIME_ZONE = 'Europe/Kaliningrad'

function tenantTimeZone(): string {
  return useAuthStore.getState().user?.timezone || FALLBACK_TIME_ZONE
}

export function formatTenantDateTime(
  iso: string,
  options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' },
): string {
  return new Date(iso).toLocaleString('ru', { ...options, timeZone: tenantTimeZone() })
}

export function formatTenantTime(
  iso: string,
  options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' },
): string {
  return new Date(iso).toLocaleTimeString('ru', { ...options, timeZone: tenantTimeZone() })
}
